var snackbarMixin = {
    methods: {
        showSnackbar(type, text) {
            this.$store.dispatch('showSnackbar', {
                show: true,
                type: type,
                text: text,
                timeout: type == 'error' ? 4000 : 1500,
            })
        },
        hideSnackbar(index) {
            this.$store.dispatch('hideSnackbar', index)
        },
    },
}
/*
 * Use within components as:
 * this.showSnackbar('info', 'This just happened and you might be interested')
 */
export default snackbarMixin
